export default "/_next/static/images/header-bg-36a734d886a883349957bd9b57de36d9.png";